<div class="pageNotFound d-flex align-items-center justify-content-center">
  <div class="bg-white rounded2 px-4 py-4">
    <p class="text-blue">Error code : <b>404</b></p>
    <p class="text-blue">
      Oops! We can't seem to find the page you are looking for.
    </p>
    <div><button class="action details" [routerLink]="['/']">Home</button></div>
  </div>
</div>
